import { Box, Card, CardContent, Grid, Typography } from "@mui/material"
import { useContext } from "react";

import CompanyContext 		from "../context";

import LoadingCard 			from "../../Dashboard/components/LoadingCard";
import StockQuoteChart 		from "../../../components/StockQuoteChart";
import IndicatorCard 		from "./IndicatorCard";

const TabGeneral = () => {
	const { company, selectedStock, indicators, isNotesOpen }	= useContext(CompanyContext)

	if (!company ) {
		return (<LoadingCard/>)
	}
	
	return (
		<Grid container spacing={2}>
			<Grid item xs={12} lg={2}>
				<Card variant="outlined" sx={{height: '100%', width: '100%'}}>
					<CardContent>
						<Typography variant="h6"><strong>{company.name}</strong></Typography>
						<Typography><strong>Setor:</strong> {company.sector}</Typography>
						<Typography><strong>Segmento:</strong> {company.industry}</Typography>
						<Typography><strong>IPO:</strong> {new Date(company.ipoDate).getFullYear()} ({new Date().getFullYear() - new Date(company.ipoDate).getFullYear()} anos)</Typography>
					</CardContent>
				</Card>	
			</Grid>				
			<Grid item xs={12} lg={10}>
				<Card variant="outlined" sx={{height: '100%'}}>
					<CardContent>
						<Typography>{company.description}</Typography>
					</CardContent>
				</Card>
			</Grid>
			<Grid item xs={12} lg={isNotesOpen ? 12 : 4}>
				<Grid container spacing={2}>
					<Grid item xs={12} sm={6}><IndicatorCard size={isNotesOpen ? "xs" : "sm"} data={indicators} indicator={'marketCap'} height={90}/></Grid>
					<Grid item xs={12} sm={6}><IndicatorCard size={isNotesOpen ? "xs" : "sm"} data={indicators} indicator={'priceEarnings'} height={90}/></Grid>
					<Grid item xs={12} sm={6}><IndicatorCard size={isNotesOpen ? "xs" : "sm"} data={indicators} indicator={'bookValue'} height={90}/></Grid>
					<Grid item xs={12} sm={6}><IndicatorCard size={isNotesOpen ? "xs" : "sm"} data={indicators} indicator={'graham'} height={90}/></Grid>
					<Grid item xs={12} sm={6}><IndicatorCard size={isNotesOpen ? "xs" : "sm"} data={indicators} indicator={'roe'} height={90}/></Grid>
					<Grid item xs={12} sm={6}><IndicatorCard size={isNotesOpen ? "xs" : "sm"} data={indicators} indicator={'dividendYield'} height={90}/></Grid>
					<Grid item xs={12} sm={6}><IndicatorCard size={isNotesOpen ? "xs" : "sm"} data={indicators} indicator={'netDebtToEbitda'} height={90}/></Grid>
					<Grid item xs={12} sm={6}><IndicatorCard size={isNotesOpen ? "xs" : "sm"} data={indicators} indicator={'cagrNetIncome5y'} height={90}/></Grid>
				</Grid>
			</Grid>				
			<Grid item xs={12} lg={isNotesOpen ? 12 : 8}>
				<Card variant="outlined">
					<CardContent>
						<StockQuoteChart ticker={selectedStock} height={346}/>
					</CardContent>
				</Card>
			</Grid>				
		</Grid>
	)
}

export default TabGeneral